
const PROD_TC_ORIGIN =
  process.env.TC_PROD_ORIGIN || "https://timescontrarian.com";
const STAGING_TC_ORIGIN =
  process.env.TC_STAGING_ORIGIN || "https://dev.timescontrarian.com";

const DEV_PARENT_HOSTS = new Set(
  (process.env.TC_DEV_PARENT_HOSTS ||
    "nya-dev.shakeypictures.com,localhost,127.0.0.1")
    .split(",")
    .map((h) => h.trim())
    .filter(Boolean)
);

const parentHost =
  typeof window !== "undefined" && window.location
    ? window.location.hostname
    : "";

const isDevParent = DEV_PARENT_HOSTS.has(parentHost);


export const TC_ORIGIN = isDevParent ? STAGING_TC_ORIGIN : PROD_TC_ORIGIN;

// Every origin the paper has ever been served from. Used ONLY to classify the
// url carried by an inbound tc-nav message (see tc-url.js) — a tc-nav pointing
// at one of these means the reader moved within the paper, anything else means
// they clicked a link out of it. Never use this list to validate an inbound
// message origin or as a postMessage target: both stay strictly TC_ORIGIN.
export const TC_KNOWN_ORIGINS = Array.from(
  new Set([
    PROD_TC_ORIGIN,
    STAGING_TC_ORIGIN,
    "https://timescontrarian.com",
    "https://www.timescontrarian.com",
    "https://dev.timescontrarian.com",
    "https://thetimescontrarian.mystagingwebsite.com",
    "https://timescontrarian.mystagingwebsite.com",
  ])
);

// Build the iframe src for a path within the paper. tcPath is expected to be
// root-relative and already carry WordPress' canonical trailing slash.
export const tcEmbedUrl = (tcPath = "/") =>
  `${TC_ORIGIN}${tcPath.startsWith("/") ? tcPath : `/${tcPath}`}`;

export const TC_EMBED_URL = tcEmbedUrl("/");
